import React from "react";
import type { FC } from "react";

import cn from "classnames";

import { IndicatorCore } from "../helper/IndicatorCore";

import type { IndicatorProps } from "./types";

import classes from "./Indicator.styl";

export const INDICATOR_DISPLAY_NAME = "Indicator";

/**
 * Базовый компонент, фокусирующий на себе внимание пользователя и информирующий о количестве новой/непросмотренной информации.
 *
 * <a href="https://www.figma.com/design/vTg3KAvmAXA9LigeyiqCWL/%F0%9F%92%A0-Base-Components?m=auto&node-id=5616-171530&t=ppTs777YfI1tVhqR-1" target="_blank">Спека</a>
 */
export const Indicator: FC<IndicatorProps> = ({
    "data-tsid": tsid = INDICATOR_DISPLAY_NAME,
    size = "8",
    pulse = "false",
    ...restProps
}) => {
    const wrapperClasses = cn(classes["indicator"], {
        [classes["__pulse"]]: pulse,
        [classes[`__size-${size}`]]: size,
    });

    return (
        <IndicatorCore
            {...restProps}
            className={wrapperClasses}
            data-tsid={tsid}
            data-uikit={INDICATOR_DISPLAY_NAME}
        />
    );
};

Indicator.displayName = INDICATOR_DISPLAY_NAME;
